// Bottom CTA — second chance to convert.
import { CtaPair } from "../components/CtaPair";
import { Mascot } from "../components/Mascot";

export function BottomCTA() {
  return (
    <section className="px-[clamp(16px,3vw,40px)] pt-24 pb-16">
      <div className="bottom-cta-card relative mx-auto max-w-[1440px] overflow-hidden rounded-[32px] bg-[radial-gradient(ellipse_at_50%_50%,#4F46E5_0%,#6366F1_45%,#818CF8_100%)] px-[clamp(40px,6vw,120px)] py-[clamp(56px,7vw,96px)] text-center shadow-[0_40px_80px_-30px_rgba(67,56,202,0.5)]">
        {/* decorative companions — nestled inside the card corners */}
        <div className="absolute bottom-6 left-6 rotate-[-10deg] opacity-95 [filter:drop-shadow(0_12px_24px_rgba(0,0,0,0.3))]">
          <Mascot name="Quill" size={160} full />
        </div>
        <div className="absolute top-6 right-6 rotate-[10deg] opacity-95 [filter:drop-shadow(0_12px_24px_rgba(0,0,0,0.3))]">
          <Mascot name="Sage" size={160} full />
        </div>

        <div className="relative z-[2]">
          <h2 className="font-companion tracking-[-0.01em] mt-0 mb-4 text-[clamp(36px,5vw,56px)] font-bold leading-[1.05] tracking-[-0.03em] text-white [text-wrap:balance]">
            Ready to try Companion?
          </h2>
          <p className="mx-auto mb-9 max-w-[480px] text-lg leading-[1.55] text-white/95 [text-wrap:pretty]">
            Get 500 free Treats when you get started with Companion.
          </p>
          <CtaPair tone="dark" size="lg" align="center" />
        </div>
      </div>
    </section>
  );
}
